import moment from 'moment';
import Moment from 'react-moment';
import { forwardRef } from 'react';

const bodyStyle = {
    margin: "40px",
}
const tableStyle = {
    margin: '0 auto',
    borderCollapse: 'collapse',
    width: '870px'
}
const tdStyleHeader = {
    color: '#333',
    padding: '0',
    font: 'bold 10px dotum',
    textAlign: 'right'
}
const tdStyleBig = {
    color: '#333',
    padding: '15px',
    font: 'bold 30px dotum',
    textAlign: 'center'
}
const basicStyle = {
    padding: '8px',
    font: 'bold 12px dotum',    
    border: '1px solid #ddd'
}
const tdStyle1 = {
    ...basicStyle,
    backgroundColor: '#f9f9f9',
    textAlign: 'center'
}
const tdStyle3 = {
    ...basicStyle,
    textAlign: 'center'
}
const tdStyle4 = {
    ...basicStyle,
    border: 'none'
}
const tdStyle5 = {
    padding: '8px',
    font: 'bold 12px dotum'
}

const currencyLocale = Intl.NumberFormat('ko-KR');

const PrintDeliveryForm = forwardRef((props, ref) => {    
    const { malls, list } = props;
    const orderId = list[0].orderid;
    const member = {
        com_name: list[0].com_name,
        name: list[0].name,
        phone: list[0].phone,
        email: list[0].email,
        com_zip: list[0].com_zip,
        com_addr1: list[0].com_addr1,
        com_addr2: list[0].com_addr2
    };

    const sum = list.reduce((partialSum, a) => partialSum + a.sprice, 0);
    const totalQty = list.reduce((partialSum, a) => partialSum + a.qty, 0);

    return (
        <div style={bodyStyle} ref={ref}>
            <style>
                {`
                @media print {
                    html, body {
                        height: initial !important;
                        overflow: initial !important;        
                        -webkit-print-color-adjust: exact;
                    }                    
                    .prt-spec-table {
                        width: 100%;
                    }
                }
                `}
            </style>            
            <table style={tableStyle}>
                <tbody>
                    <tr>
                        <td rowSpan={3} colSpan={3} style={{padding: '0'}}>
                            <img src='/images/logo.png' alt="logo" width="145" height="50" />
                        </td>
                        <td colSpan={7} style={tdStyleHeader}>https://www.aladdinsci.net</td>
                    </tr>
                    <tr>
                        <td colSpan={7} style={tdStyleHeader}>주소: {malls.address}</td>
                    </tr>
                    <tr>
                        <td colSpan={7} style={tdStyleHeader}>TEL: {malls.tel}</td>
                    </tr>
                    <tr>
                        <td colSpan={10} style={tdStyleBig}>납품명세서</td>
                    </tr>
                    <tr>
                        <td colSpan={10} style={tdStyle5}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td rowSpan={2} colSpan={5} width="40%" style={tdStyle3}> {member.com_name} 귀중</td>
                        <td colSpan={1} width="10%" style={tdStyle4}></td>
                        <td colSpan={1} width="10%" style={tdStyle1}>일련번호</td>
                        <td colSpan={1} width="10%" style={tdStyle3}>{moment().format('YYMMDDhhmmss')}</td>
                        <td colSpan={1} width="10%" style={tdStyle1}>TEL</td>
                        <td colSpan={1} width="10%" style={tdStyle3}>{malls.tel}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} style={tdStyle4}>&nbsp;</td>
                        <td colSpan={1} style={tdStyle1}>사업자등록번호</td>
                        <td colSpan={1} style={tdStyle3}>{malls.license_num}</td>
                        <td colSpan={1} style={tdStyle1}>성명</td>
                        <td colSpan={1} style={tdStyle3}><img src="/images/stamp.png" alt="상호" /></td>
                    </tr>
                    <tr>
                        <td colSpan={5} style={tdStyle3}>{member?.com_zip}, {member?.com_addr1} {member?.com_addr2}</td>
                        <td colSpan={1} style={tdStyle4}>&nbsp;</td>
                        <td colSpan={1} style={tdStyle1}>상호</td>
                        <td colSpan={3} style={tdStyle3}>{malls.company_name}</td>
                    </tr>
                    <tr>
                        <td colSpan={1} style={tdStyle1}>주문번호</td>
                        <td colSpan={4} style={tdStyle3}>{orderId}</td>
                        <td colSpan={1} style={tdStyle4}>&nbsp;</td>
                        <td colSpan={1} style={tdStyle1}>주소</td>
                        <td colSpan={3} style={tdStyle3}>{malls.address}</td>
                    </tr>
                    <tr>
                        <td colSpan={10} style={tdStyle5}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td colSpan={10} style={tdStyle5}>&nbsp;</td>
                    </tr>
                    <tr>
                        <th colSpan={1} style={tdStyle1}>월/일</th>
                        <th colSpan={2} style={tdStyle1}>Cat No</th>
                        <th colSpan={1} style={tdStyle1}>용량</th>
                        <th colSpan={5} style={tdStyle1}>품명 및 규격</th>
                        <th colSpan={1} style={tdStyle1}>수량</th>
                    </tr>
                    {
                        list.map((item, index) =>
                            <tr key={index}>
                                <td colSpan={1} style={tdStyle3}><Moment format="MM/DD">{item.ctime}</Moment></td>
                                <td colSpan={2} style={tdStyle3}>{item.cat_id}</td>
                                <td colSpan={1} style={tdStyle3}>{item.pd_packing}</td>
                                <td colSpan={5} style={tdStyle3}>{item.name} / {item.spec_desc}</td>
                                <td colSpan={1} style={tdStyle3}>{item.qty}</td>
                            </tr>
                        )
                    }
                </tbody>                
            </table>
        </div>
    );
});

export default PrintDeliveryForm